import createAPIServices from './createAPIServices'
import { baseUrlPhotoCloud } from './createAPIServices'


const api = createAPIServices()

// api user
export const sendMessage = (receiver_uid,receiver_oid,body)  => {
    return api.makeAuthRequest({
        url: `/message/sentalways?receiver_uid=${receiver_uid}&receiver_oid=${receiver_oid}`,
        method: 'POST',
        data: body,
    })
}
export const getListReplyInReply = (reply_id) =>{
    return api.makeAuthRequest({
        url: `/message/reply/${reply_id}`,
        method: 'GET',
    })
}
export const sendReplyInReply = (body) =>{
    return api.makeAuthRequest({
        url: `/message/reply/reply2`,
        method: 'POST',
        data: body
    })
}
export const replyMessage = (body)  => {
    return api.makeAuthRequest({
        url: `/message/reply`,
        method: 'POST',
        data: body,
    })
}
export const getListReply = (messid)  => {
    return api.makeAuthRequest({
        url: `/message/${messid}/reply`,
        method: 'GET',
    })
}

export const getListMessage = (uid, status, page_number, text )  => {
    return api.makeAuthRequest({
        url: `/message/user/${uid}?page_number=${page_number}&page_size=${40}&status=${status}&text=${text}`,
        method: 'GET',
    })
}